import React from "react";

const Network = () => {
  return (
    <div className="article-container">
      <h2>Network</h2>
      <div className=" network-container">
        <div>
          To learn more about Algorave, live and creative coding, open-source
          music-making tools and all that, you can start here:
          <ul>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://media.ccc.de/v/rc3-2021-chaoszone-345-what-is-algorave"
              >
                What is Algorave? | Alexandra Cardenas at rC3 NOWHERE
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://github.com/toplap/awesome-livecoding"
              >
                All things live coding (a comprehensive list)
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://toplap.org/about/"
              >
                TOPLAP organisation
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://tidalcycles.org/"
              >
                TidalCycles
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://supercollider.github.io/"
              >
                SuperCollider
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://wiki.xxiivv.com/site/orca.html"
              >
                ORCΛ
              </a>
            </li>
          </ul>
        </div>
        <div>
          As for places to get in touch with other livecoding people, there's
          also a lot of <strong>Discord</strong> servers where you can get in
          touch.
          <br />
          Our Discord chat is this one:
          <ul>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://discord.gg/CPs6KcMBk6"
              >
                LOL2
              </a>
            </li>
          </ul>
          And then there's:
          <ul>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://discord.gg/pYrVh6VBBH"
              >
                TOPLAP live coding
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://discord.gg/yRsFKkhe"
              >
                TOPLAP Berlin
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://discord.gg/4MP4N3JX"
              >
                TOPLAP Karlsruhe
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://discord.gg/4q8WDHm8"
              >
                TOPLAP Düsseldorf
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://discord.gg/wXkGbJ65Mb"
              >
                TidalCycles
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://discord.gg/DkzsaHzK"
              >
                SuperCollider
              </a>
            </li>
          </ul>
        </div>
        <div>
          Here's some active <strong>online forums</strong> with
          livecoding-related discussions:
          <ul>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://forum.toplap.org/"
              >
                TOPLAP
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://scsynth.org/"
              >
                SuperCollider
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://club.tidalcycles.org"
              >
                TidalCycles club
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://llllllll.co/"
              >
                lines | llllllll
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
export default Network;
